import { GenericStyleModel } from '../../Styles/models/generic-style.model';
import { BlockDisplayTypeEnum } from '../enums/block-display-type.enum';

export abstract class DisplayElementModel {
    styles?: GenericStyleModel;
    isBoundToGlobalStyles?: boolean;
    settings?: any;
    placeholderHeight?: number;
    displayType?: BlockDisplayTypeEnum;
    enableEditingNote?: boolean;
    loading?: boolean = false;
    automaticallyGenerated?: boolean = false;

    // F/E use only
    canAutomaticallyGenerated?: boolean = false;

    /**
     * Determines whether or not the template had enough data to render.
     * If false, then the placeholder will be rendered.
     *
     * @returns True if the template can be rendered, false otherwise
     */
    abstract canRender(): boolean;

    /**
     * Creates a clone of this display element model.
     *
     * @returns A copy of this display element.
     */
    abstract clone(): DisplayElementModel;

    /**
     * Checks the changes and verifies if more changes need to occur
     *
     * @returns true if changes are triggered, false otherwise
     */
    abstract onUpdate(): boolean | Promise<boolean>;

    /**
     * Checks that this display element is equal to another (for saving)
     *
     * @param other Another display element
     *
     * @returns True if display elements are the same, false otherwise
     */
    abstract isEqual(other: DisplayElementModel): boolean;
}
